import Cursor from './components/Cursor';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Candidature from './components/Candidature';
import Footer from './components/Footer';

export default function App() {
  return (
    <div style={{ fontFamily: "'Syne', sans-serif", color: '#e2f0f5', background: '#050a0e' }}>
      <Cursor />
      <Navbar />
      <Hero />
      <About />
      <Skills />
      <Projects />
      <Experience />
      <Candidature />
      <Footer />
    </div>
  );
}
